import Report6ReportingPeriod, {
  IReport6ReportingPeriod
} from "../../../model/report/Report6ReportingPeriod";
import Report6RiskCriteria, {
  IReport6RiskCriteria
} from "../../../model/report/Report6RiskCriteria";
import Report6Applicant, {
  IReport6Applicant
} from "../../../model/report/Report6Applicant";
import Report6Report, {
  IReport6Report
} from "../../../model/report/Report6Report";
import { formatBooleanValue } from "../../..";

const ApplicantsMapper = (json = []) => {
  return json.map((item: any) => {
    return Report6Applicant(item);
  });
};

const ReportingPeriodsMapper = (json = []) => {
  return json.map((item: any) => {
    let reportingPeriod = Report6ReportingPeriod(item);
    reportingPeriod.additionalEvaluation = formatBooleanValue(
      item.additionalEvaluation
    );
    return reportingPeriod;
  });
};

const ReportMapper = (json = []) => {
  return json.map((item: any) => {
    let report6Report = Report6Report(item);
    report6Report.financialImbalance = formatBooleanValue(
      item.financialImbalance
    );

    return report6Report;
  });
};

const RiskCriteriaMapper = (json = []) => {
  return json.map((item: any) => {
    return Report6RiskCriteria(item);
  });
};

const findRiskCriterias = (
  riskCriterias: IReport6RiskCriteria[],
  report: IReport6Report
): IReport6RiskCriteria[] => {
  return riskCriterias.filter(
    (riskCriteria: IReport6RiskCriteria) => riskCriteria.reportId === report.id
  );
};

const findReports = (
  reports: IReport6Report[],
  reportingPeriod: IReport6ReportingPeriod
): IReport6Report[] => {
  return reports.filter(
    (report: IReport6Report) =>
      report.reportingPeriodId === reportingPeriod.reportingPeriodId &&
      report.applicantReportingPeriodId ===
        reportingPeriod.applicantReportingPeriodId
  );
};

const findReportingPeriods = (
  reportingPeriods: IReport6ReportingPeriod[],
  applicant: IReport6Applicant
): IReport6ReportingPeriod[] => {
  return reportingPeriods.filter(
    (reportingPeriod: IReport6ReportingPeriod) =>
      reportingPeriod.applicantId === applicant.id
  );
};

function groupElements(
  applicants: IReport6Applicant[],
  reportingPeriods: IReport6ReportingPeriod[],
  reports: IReport6Report[],
  riskCriterias: IReport6RiskCriteria[]
) {
  applicants = applicants.map((applicant: IReport6Applicant) => {
    applicant.reportingPeriods = findReportingPeriods(
      reportingPeriods,
      applicant
    );
    applicant.reportingPeriods = applicant.reportingPeriods.map(
      (reportingPeriod: IReport6ReportingPeriod) => {
        reportingPeriod.reports = findReports(reports, reportingPeriod);

        reportingPeriod.reports = reportingPeriod.reports.map(
          (report: IReport6Report) => {
            report.riskCriterias = findRiskCriterias(riskCriterias, report);
            return report;
          }
        );
        return reportingPeriod;
      }
    );
    return applicant;
  });
  return applicants;
}

const Report6Mapper = (
  applicants: any,
  reportingPeriods: any,
  reports: any,
  riskCriterias: any
) => {
  let applicantsMappedList = ApplicantsMapper(applicants);
  let reportingPeriodsMappedList = ReportingPeriodsMapper(reportingPeriods);
  let reportsMappedList = ReportMapper(reports);
  let riskCriteriasMappedList = RiskCriteriaMapper(riskCriterias);

  return groupElements(
    applicantsMappedList,
    reportingPeriodsMappedList,
    reportsMappedList,
    riskCriteriasMappedList
  );
};

export default Report6Mapper;
